module.exports = __webpack_public_path__ + "img/antes_despues_134.5883548e.png";